import React, { useEffect } from 'react';
import GenericNavBar from 'newComponents/GenericNavBar';

import { useTour } from 'hooks/useTour';
import { Container, PageTitle, Separator } from './styles';
import FormProfile from './FormProfile';
import FormUser from './FormUser';
import { TableWrap } from '../BankSlip/styles';
import TourBalloon from '../../newComponents/NewTour/TourBallon';

const Profile: React.FC = () => {
  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    setTourType('profile');
    setSteps(1);
  }, [setTourType, setSteps]);

  useEffect(() => {
    if (showTour && tourType === 'profile' && tourStep < 2) {
      const el = document.getElementById('user-menu');
      if (el) {
        el.scrollIntoView();
      }
    }
  }, [showTour, tourType, tourStep]);

  return (
    <GenericNavBar breadcrump="› Perfil" selected="perfil" intro={() => true}>
      <Container>
        <PageTitle>Perfil</PageTitle>
        <Separator />
        <TableWrap
          showTour={showTour && tourType === 'profile' && tourStep === 1}
        >
          <FormProfile />
          <PageTitle>Dados do usuário</PageTitle>
          <Separator />
          <FormUser id="form-user" />
          {showTour && tourType === 'profile' && tourStep === 1 && (
            <TourBalloon
              title="Dados cadastrais"
              content="Aqui você encontra as informações do seu cadastro de perfil, você pode realizar a troca de senha clicando em Alterar senha"
              position={{
                left: '30%',
                right: '0',
                top: '-212px',
                width: '342px',
                arrowPosition: 'bottom',
                maxWidth: 'unset',
                boxShadow: false,
              }}
            />
          )}
        </TableWrap>
      </Container>
    </GenericNavBar>
  );
};

export default Profile;
